import {createTranslationMessages} from '@backstage/core-plugin-api/alpha';
import {scaffolderReactTranslationRef} from '@backstage/plugin-scaffolder-react/alpha';

export const scaffolderReactPtbr = createTranslationMessages({
    ref: scaffolderReactTranslationRef,
    messages: {
        "workflow.noDescription": "Sem descrição",
        "passwordWidget.content": "Este widget não é seguro. Por favor, use [`ui:field: Secret`](https://backstage.io/docs/features/software-templates/writing-templates/#using-secrets) ao invés de `ui:widget: password`",
        "scaffolderPageContextMenu.createLabel": "Criar",
        "scaffolderPageContextMenu.moreLabel": "mais",
        "scaffolderPageContextMenu.editorLabel": "Gerenciar Templates",
        "scaffolderPageContextMenu.actionsLabel": "Ações Instaladas",
        "scaffolderPageContextMenu.tasksLabel": "Lista de Tarefas",
        "stepper.backButtonText": "Voltar",
        "stepper.createButtonText": "Criar",
        "stepper.reviewButtonText": "Revisar",
        "stepper.stepIndexLabel": "Passo {{index, number}}",
        "stepper.nextButtonText": "Próximo",
        "templateCategoryPicker.title": "Categorias",
        "templateCard.noDescription": "Sem descrição",
        "templateCard.chooseButtonText": "Criar",
        "cardHeader.detailBtnTitle": "Mostrar detalhes do template",
        "templateOutputs.title": "Saída de Texto",
    },
});

export default scaffolderReactPtbr;
